<template>
  <app-modal class="growing-methods-create" @close="close">
    <app-modal-filled @close="close">
      <div class="content">
        <app-text-input styling="inline-inverse" v-model="data.name" :label="$ml.get(`Method name`)"/>
        <app-btn :loading="loading" @click="create">{{ $ml.get(`create`) }}</app-btn>
      </div>
    </app-modal-filled>
  </app-modal>
</template>

<script>
import { CropAPI }  from '@/api'
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      data: {
        name: '',
      },
      err: {
        name: false,
      },
    }
  },

  computed: {
    ...mapGetters({
      parent: 'crop/variety',
    })
  },

  methods: {
    create() {

      if(!this.data.name.length) {
        this.err.name = true;
        return;
      }

      this.loading = true;
      return CropAPI.createCropGrowingMethod({
        name: this.data.name,
        varietyId: this.parent.id,
      }).then(res => {
        this.updateParentList(res.data);
      }).finally(res => {
        this.loading = false;
        this.close();
      });
    },
    updateParentList(item = null) {
      this.$emit('update', item);
    },
    close() {
      this.$emit('close');
    },
  }
}
</script>

<style lang="scss" scoped>

.growing-methods-create {
  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .app-text-input {
    margin-right: 10px;
    flex-grow: 1;
    width: unset;
  }
}

</style>
